<template>
  <div class="modal confirmmodal-wrap">
    <div class="confirmmodal">
      <h1 class="confirmmodal-nontitle">
        <slot name="confirmmodal-nontitle"></slot>
      </h1>
      <h1 class="confirmmodal-title">
        <slot name="confirmmodal-title"></slot>
      </h1>
      <p class="alertmodal-desc">
        <slot name="confirmmodal-desc"></slot>
      </p>
      <ul class="btngroup">
        <li class="leftbtn">
          <BasicButton :boxsize="'md'" :bgcolor="'bg-black200'" :fontcolor="'ft-black'" @click-btn="onClickBtnNo">
            <template #btnname>
              아니오
            </template>
          </BasicButton>
        </li>
        <li class="leftbtn">
          <BasicButton :boxsize="'md'" @click-btn="onClickBtnYes">
            <template #btnname>
              네
            </template>
          </BasicButton>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import BasicButton from '../BasicButton/BasicButton.vue';

export default {
  components: {
    BasicButton
  },
  emits: ['click-no', 'click-yes'],
  methods: {
    onClickBtnNo() {
      this.$emit('click-no');
    },
    onClickBtnYes() {
      this.$emit('click-yes');
    }
  }
};
</script>
<style scoped src="@/assets/css/confirmyesnov2/confirmyesnov2.css"></style>
